// Author : Vishnu
//Version :0.0.1
// MODIFIED DATE: 04/8/2025
import { docodeHexResponse } from '../../_common/common.utils';
import groupActionTypes from './group.types';

const INITIAL_STATE = {
	addGroupDetailsResponse: null,

	getGroupListResponse: null,
	getGroupListArr: [],

	fetchAllGroupResponse: null,
	fetchAllGroupArr: [],

	fetchAllApprovedMemberResponse: null,
	fetchAllApprovedMemberArr: [],

	allOfficerResponse: null,
	allOfficerArr: [],

	allGroupDetailsResponse: null,
	allGroupDetailsArr: [],

	branchOfficerResponse: null,
	branchOfficerArr: [],

	updateExistGroupResponse: null,
	removeMemberFromGroupResponse: null,
	deleteGroupResponse: null,
};

const groupReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** ADD GROUP DETAILS START *********************** */
		case groupActionTypes.ADD_GROUP_DETAILS_SUCCESS:
			return { ...state, addGroupDetailsResponse: action.payload };

		case groupActionTypes.ADD_GROUP_DETAILS_FAILURE:
			return { ...state, addGroupDetailsResponse: action.payload };

		case groupActionTypes.ADD_GROUP_DETAILS_RESPONSE_CHANGED:
			return { ...state, addGroupDetailsResponse: null };
		/** ***************** ADD GROUP DETAILS START *********************** */

		/** ***************** GET GROUP LIST START *********************** */
		case groupActionTypes.GET_GROUP_LIST_SUCCESS:
			return {
				...state,
				getGroupListResponse: action.payload,
				getGroupListArr: docodeHexResponse(action.payload, 'GetAllGroupListKey'),
			};

		case groupActionTypes.GET_GROUP_LIST_FAILURE:
			return { ...state, getGroupListResponse: action.payload, getGroupListArr: [] };

		case groupActionTypes.GET_GROUP_LIST_RESPONSE_CHANGED:
			return { ...state, getGroupListResponse: null };
		/** ***************** GET GROUP LIST END *********************** */

		/** ***************** FETCH ALL GROUP START *********************** */
		case groupActionTypes.FETCH_ALL_GROUP_SUCCESS:
			return {
				...state,
				fetchAllGroupResponse: action.payload,
				fetchAllGroupArr: docodeHexResponse(action.payload, 'FetchAllGroupListKey'),
			};

		case groupActionTypes.FETCH_ALL_GROUP_FAILURE:
			return { ...state, fetchAllGroupResponse: action.payload, fetchAllGroupArr: [] };

		case groupActionTypes.FETCH_ALL_GROUP_RESPONSE_CHANGED:
			return { ...state, fetchAllGroupResponse: null };
		/** ***************** FETCH ALL GROUP END *********************** */

		/** ***************** FETCH ALL APPROVED MEMBER START *********************** */
		case groupActionTypes.FETCH_ALL_APPROVED_MEMBER_SUCCESS:
			return {
				...state,
				fetchAllApprovedMemberResponse: action.payload,
				fetchAllApprovedMemberArr: docodeHexResponse(
					action.payload,
					'FetchApprovedMembersKey',
				),
			};

		case groupActionTypes.FETCH_ALL_APPROVED_MEMBER_FAILURE:
			return {
				...state,
				fetchAllApprovedMemberResponse: action.payload,
				fetchAllApprovedMemberArr: [],
			};

		case groupActionTypes.FETCH_ALL_APPROVED_MEMBER_RESPONSE_CHANGED:
			return { ...state, fetchAllApprovedMemberResponse: null };
		/** ***************** FETCH ALL APPROVED MEMBER END *********************** */

		/** ***************** GET ALL OFFICER LIST START *********************** */
		case groupActionTypes.GET_ALL_OFFICER_SUCCESS:
			return {
				...state,
				allOfficerResponse: action.payload,
				allOfficerArr: docodeHexResponse(action.payload, 'GetAllOfficerKey'),
			};

		case groupActionTypes.GET_ALL_OFFICER_FAILURE:
			return { ...state, allOfficerResponse: action.payload, allOfficerArr: [] };

		case groupActionTypes.GET_ALL_OFFICER_RESPONSE_CHANGED:
			return { ...state, allOfficerResponse: null };
		/** ***************** GET ALL OFFICER LIST END *********************** */

		/** ***************** GET ALL GROUP DETAILS START *********************** */
		case groupActionTypes.GET_ALL_GROUP_DETAILS_SUCCESS:
			return {
				...state,
				allGroupDetailsResponse: action.payload,
				allGroupDetailsArr: docodeHexResponse(action.payload, 'GetAllGroupDetailsKey'),
			};

		case groupActionTypes.GET_ALL_GROUP_DETAILS_FAILURE:
			return { ...state, allGroupDetailsResponse: action.payload, allGroupDetailsArr: [] };

		case groupActionTypes.GET_ALL_GROUP_DETAILS_RESPONSE_CHANGED:
			return { ...state, allGroupDetailsResponse: null };
		/** ***************** GET ALL GROUP DETAILS END *********************** */

		/** ***************** GET BRANCH OFFICER LIST START *********************** */
		case groupActionTypes.GET_BRANCH_OFFICER_SUCCESS:
			return {
				...state,
				branchOfficerResponse: action.payload,
				branchOfficerArr: docodeHexResponse(action.payload, 'BranchOfficerListKey'),
			};

		case groupActionTypes.GET_BRANCH_OFFICER_FAILURE:
			return { ...state, branchOfficerResponse: action.payload, branchOfficerArr: [] };

		case groupActionTypes.GET_BRANCH_OFFICER_RESPONSE_CHANGED:
			return { ...state, branchOfficerResponse: null };
		/** ***************** GET BRANCH OFFICER LIST END *********************** */

		/** ***************** UPDATE EXIST GROUP START *********************** */
		case groupActionTypes.UPDATE_EXIST_GROUP_SUCCESS:
			return { ...state, updateExistGroupResponse: action.payload };

		case groupActionTypes.UPDATE_EXIST_GROUP_FAILURE:
			return { ...state, updateExistGroupResponse: action.payload };

		case groupActionTypes.UPDATE_EXIST_GROUP_RESPONSE_CHANGED:
			return { ...state, updateExistGroupResponse: null };
		/** ***************** UPDATE EXIST GROUP END *********************** */

		/** ***************** REMOVE MEMBER FROM GROUP START *********************** */
		case groupActionTypes.REMOVE_MEMBER_FROM_SUCCESS:
			return { ...state, removeMemberFromGroupResponse: action.payload };

		case groupActionTypes.REMOVE_MEMBER_FROM_FAILURE:
			return { ...state, removeMemberFromGroupResponse: action.payload };

		case groupActionTypes.REMOVE_MEMBER_FROM_RESPONSE_CHANGED:
			return { ...state, removeMemberFromGroupResponse: null };
		/** ***************** REMOVE MEMBER FROM GROUP END *********************** */

		/** ***************** REMOVE GROUP START *********************** */
		case groupActionTypes.DELETE_GROUP_SUCCESS:
			return { ...state, deleteGroupResponse: action.payload };

		case groupActionTypes.DELETE_GROUP_FAILURE:
			return { ...state, deleteGroupResponse: action.payload };

		case groupActionTypes.DELETE_GROUP_RESPONSE_CHANGED:
			return { ...state, deleteGroupResponse: null };
		/** ***************** REMOVE GROUP END *********************** */
		default:
			return state;
	}
};

export default groupReducer;
